import {
  isLoaded as isLoadedIntList,
  ProductRiderIntModel,
  UnassignedProductRiderIntModel,
} from 'ApplicationEntry/models/ProductsRiders/ProductRiderIntModel';
import {
  isLoaded as isLoadedStringList,
  ProductRiderStringModel,
  UnassignedProductRiderStringModel,
} from 'ApplicationEntry/models/ProductsRiders/ProductRiderStringModel';
import {Loaded} from 'Core/models/Async';
import {EmptyString, isNonEmptyString, NonEmptyString, StringUnion} from 'Core/models/EmptyString';
import {ToPartialMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';

type DisabilityProps = {
  plan: StringUnion;
  premium: StringUnion;
  calculatedPremium: StringUnion;
  cwa: StringUnion;
  onJobRiderMonthly: StringUnion;
  monthlySalary: StringUnion;
  type: StringUnion;
  accident: StringUnion;
  sickness: StringUnion;
  occClass: StringUnion;
  monthlyBenefit: StringUnion;
  riderType: StringUnion;
  accidentRiderUnit: number;
  benefitPeriod: StringUnion;
  mentalNervousRider: boolean;
  section125: boolean;
  onJobRider: boolean;
  addRider: boolean;
  planList: ProductRiderStringModel;
  typeList: ProductRiderStringModel;
  accidentList: ProductRiderStringModel;
  sicknessList: ProductRiderStringModel;
  occClassList: ProductRiderStringModel;
  riderTypeList: ProductRiderStringModel;
  riderUnitList: ProductRiderIntModel;
  benefitPeriodList: ProductRiderIntModel;
};

export class InvalidOrdDisability {
  public readonly key = 'InvalidOrdDisability';

  constructor(
    public readonly plan: StringUnion,
    public readonly premium: StringUnion,
    public readonly calculatedPremium: StringUnion,
    public readonly cwa: StringUnion,
    public readonly onJobRiderMonthly: StringUnion,
    public readonly monthlySalary: StringUnion,
    public readonly type: StringUnion,
    public readonly accident: StringUnion,
    public readonly sickness: StringUnion,
    public readonly occClass: StringUnion,
    public readonly monthlyBenefit: StringUnion,
    public readonly riderType: StringUnion,
    public readonly accidentRiderUnit: number,
    public readonly benefitPeriod: StringUnion,
    public readonly mentalNervousRider: boolean,
    public readonly section125: boolean,
    public readonly onJobRider: boolean,
    public readonly addRider: boolean,
    public readonly planList: ProductRiderStringModel,
    public readonly typeList: ProductRiderStringModel,
    public readonly accidentList: ProductRiderStringModel,
    public readonly sicknessList: ProductRiderStringModel,
    public readonly occClassList: ProductRiderStringModel,
    public readonly riderTypeList: ProductRiderStringModel,
    public readonly riderUnitList: ProductRiderIntModel,
    public readonly benefitPeriodList: ProductRiderIntModel
  ) {}
}

export class ValidOrdDisability {
  public static createApp({
    plan,
    premium,
    calculatedPremium,
    cwa,
    onJobRiderMonthly,
    monthlySalary,
    type,
    accident,
    sickness,
    occClass,
    monthlyBenefit,
    riderType,
    accidentRiderUnit,
    benefitPeriod,
    mentalNervousRider,
    section125,
    onJobRider,
    addRider,
    planList,
    typeList,
    accidentList,
    sicknessList,
    occClassList,
    riderTypeList,
    riderUnitList,
    benefitPeriodList,
  }: DisabilityProps) {
    return this.create(
      plan,
      premium,
      calculatedPremium,
      cwa,
      onJobRiderMonthly,
      monthlySalary,
      type,
      accident,
      sickness,
      occClass,
      monthlyBenefit,
      riderType,
      accidentRiderUnit,
      benefitPeriod,
      mentalNervousRider,
      section125,
      onJobRider,
      addRider,
      planList,
      typeList,
      accidentList,
      sicknessList,
      occClassList,
      riderTypeList,
      riderUnitList,
      benefitPeriodList
    );
  }

  public static create(
    plan: StringUnion,
    premium: StringUnion,
    calculatedPremium: StringUnion,
    cwa: StringUnion,
    onJobRiderMonthly: StringUnion,
    monthlySalary: StringUnion,
    type: StringUnion,
    accident: StringUnion,
    sickness: StringUnion,
    occClass: StringUnion,
    monthlyBenefit: StringUnion,
    riderType: StringUnion,
    accidentRiderUnit: number,
    benefitPeriod: StringUnion,
    mentalNervousRider: boolean,
    section125: boolean,
    onJobRider: boolean,
    addRider: boolean,
    planList: ProductRiderStringModel,
    typeList: ProductRiderStringModel,
    accidentList: ProductRiderStringModel,
    sicknessList: ProductRiderStringModel,
    occClassList: ProductRiderStringModel,
    riderTypeList: ProductRiderStringModel,
    riderUnitList: ProductRiderIntModel,
    benefitPeriodList: ProductRiderIntModel
  ) {
    return isNonEmptyString(plan) &&
      isLoadedStringList(planList) &&
      isLoadedStringList(typeList) &&
      isLoadedStringList(accidentList) &&
      isLoadedStringList(sicknessList) &&
      isLoadedStringList(occClassList) &&
      isLoadedStringList(riderTypeList) &&
      isLoadedIntList(riderUnitList) &&
      isLoadedIntList(benefitPeriodList)
      ? new ValidOrdDisability(
          plan,
          premium,
          calculatedPremium,
          cwa,
          onJobRiderMonthly,
          monthlySalary,
          type,
          accident,
          sickness,
          occClass,
          monthlyBenefit,
          riderType,
          accidentRiderUnit,
          benefitPeriod,
          mentalNervousRider,
          section125,
          onJobRider,
          addRider,
          planList,
          typeList,
          accidentList,
          sicknessList,
          occClassList,
          riderTypeList,
          riderUnitList,
          benefitPeriodList
        )
      : new InvalidOrdDisability(
          plan,
          premium,
          calculatedPremium,
          cwa,
          onJobRiderMonthly,
          monthlySalary,
          type,
          accident,
          sickness,
          occClass,
          monthlyBenefit,
          riderType,
          accidentRiderUnit,
          benefitPeriod,
          mentalNervousRider,
          section125,
          onJobRider,
          addRider,
          planList,
          typeList,
          accidentList,
          sicknessList,
          occClassList,
          riderTypeList,
          riderUnitList,
          benefitPeriodList
        );
  }

  public readonly key = 'ValidOrdDisability';
  constructor(
    public readonly plan: StringUnion,
    public readonly premium: StringUnion,
    public readonly calculatedPremium: StringUnion,
    public readonly cwa: StringUnion,
    public readonly onJobRiderMonthly: StringUnion,
    public readonly monthlySalary: StringUnion,
    public readonly type: StringUnion,
    public readonly accident: StringUnion,
    public readonly sickness: StringUnion,
    public readonly occClass: StringUnion,
    public readonly monthlyBenefit: StringUnion,
    public readonly riderType: StringUnion,
    public readonly accidentRiderUnit: number,
    public readonly benefitPeriod: StringUnion,
    public readonly mentalNervousRider: boolean,
    public readonly section125: boolean,
    public readonly onJobRider: boolean,
    public readonly addRider: boolean,
    public readonly planList: Loaded<string[]>,
    public readonly typeList: Loaded<string[]>,
    public readonly accidentList: Loaded<string[]>,
    public readonly sicknessList: Loaded<string[]>,
    public readonly occClassList: Loaded<string[]>,
    public readonly riderTypeList: Loaded<string[]>,
    public readonly riderUnitList: Loaded<number[]>,
    public readonly benefitPeriodList: Loaded<number[]>
  ) {}
}

export type OrdDisability = InvalidOrdDisability | ValidOrdDisability;

export type OrdDisabilityOptions<TReturn> = ToPartialMatchOptions<OrdDisability, 'key', TReturn>;

export const matchOrdDisability = <TReturn>(options: OrdDisabilityOptions<TReturn>) => (
  app: OrdDisability
): TReturn => {
  switch (app.key) {
    case 'InvalidOrdDisability':
      return options.InvalidOrdDisability ? options.InvalidOrdDisability(app) : options.default(app);
    case 'ValidOrdDisability':
      return options.ValidOrdDisability ? options.ValidOrdDisability(app) : options.default(app);
  }
};

export const EmptyOrdDisability = new InvalidOrdDisability(
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  -1,
  new EmptyString(),
  false,
  false,
  false,
  false,
  new UnassignedProductRiderStringModel(),
  new UnassignedProductRiderStringModel(),
  new UnassignedProductRiderStringModel(),
  new UnassignedProductRiderStringModel(),
  new UnassignedProductRiderStringModel(),
  new UnassignedProductRiderStringModel(),
  new UnassignedProductRiderIntModel(),
  new UnassignedProductRiderIntModel()
);

export const changePlan = (plan: string) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({
    ...app,
    plan: NonEmptyString.create(plan),
    monthlyBenefit: new EmptyString(),
    monthlySalary: new EmptyString(),
    premium: new EmptyString(),
    calculatedPremium: new EmptyString(),
    cwa: new EmptyString(),
    onJobRiderMonthly: new EmptyString(),
  });
export const changePremium = (premium: string) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, premium: NonEmptyString.create(premium)});
export const changeCalculatedPremium = (calculatedPremium: string) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, calculatedPremium: NonEmptyString.create(calculatedPremium)});
export const changeCWA = (cwa: string) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, cwa: NonEmptyString.create(cwa)});
export const changeOnJobMonthlyRider = (monthlyRider: string) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, onJobRiderMonthly: NonEmptyString.create(monthlyRider)});
export const changeMonthlySalary = (monthlySalary: string) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, monthlySalary: NonEmptyString.create(monthlySalary)});
export const changeType = (type: string) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({
    ...app,
    type: NonEmptyString.create(type),
    monthlyBenefit: new EmptyString(),
    monthlySalary: new EmptyString(),
    premium: new EmptyString(),
    calculatedPremium: new EmptyString(),
    cwa: new EmptyString(),
    onJobRiderMonthly: new EmptyString(),
  });
export const changeAccident = (accident: string) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, accident: NonEmptyString.create(accident)});
export const changeSickness = (sick: string) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, sickness: NonEmptyString.create(sick)});
export const changeOccClass = (occ: string) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, occClass: NonEmptyString.create(occ)});
export const changeBenefitMonthly = (monthlyBenefit: string) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, monthlyBenefit: NonEmptyString.create(monthlyBenefit)});
export const changeRiderType = (riderType: string) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, riderType: NonEmptyString.create(riderType)});
export const changeAccRiderUnit = (unit: number) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, accidentRiderUnit: unit});
export const changeBenefitPeriod = (benefit: string) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, benefitPeriod: NonEmptyString.create(benefit)});
export const changeMentalNervousRider = (rider: boolean) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, mentalNervousRider: rider});
export const changeSection125 = (section: boolean) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, section125: section});
export const changeOnJobRider = (rider: boolean) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, onJobRider: rider});
export const changeAddRider = (rider: boolean) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, addRider: rider});

export const changePlanList = (products: ProductRiderStringModel) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, planList: products});
export const changeTypeList = (products: ProductRiderStringModel) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, typeList: products});
export const changeAccidentList = (products: ProductRiderStringModel) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, accidentList: products});
export const changeSicknessList = (products: ProductRiderStringModel) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, sicknessList: products});
export const changeOccClassList = (products: ProductRiderStringModel) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, occClassList: products});
export const changeSaldOccClassList = (products: ProductRiderStringModel) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, occClassList: products});
export const changeRiderTypeList = (products: ProductRiderStringModel) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, riderTypeList: products});
export const changeBenefitPeriodList = (periodList: ProductRiderIntModel) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, benefitPeriodList: periodList});
export const changeAccRiderUnitList = (riderList: ProductRiderIntModel) => (app: OrdDisability) =>
  ValidOrdDisability.createApp({...app, riderUnitList: riderList});
